<script>
import ImportSkill from "@/view/pages/marking-exam/components/ImportSkill.vue";
import {IMPORT_READING_AND_WRITING_EXAM_STUDENT} from "@/core/services/store/marking/marking.module";

export default {
  name: "ImportSkillModal",
  components: {ImportSkill},
  props: {
    student: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      studentInfo: null,
      loading: false,
      skill: [],
      files: [],
      loadingSubmit: false,
      audioFile: null,
      audioFileUrl: '',
      listeningScore: null,
      readingScore: null,
      scoreOptions: [],
      FILE_TYPE: {
        AUDIO: 'audio',
        IMAGE: 'image'
      }
    }
  },
  mounted() {
    this.getOptionScore()
  },
  methods: {
    onFileChange(event, type) {
      const files = Array.from(event.target.files || []);

      if (!files.length) return;

      const imageExtensions = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'webp',
        'bmp',
        'heic',
        'heif',
      ];

      const newFiles = [];

      for (const file of files) {
        const extension = file.name
          .split('.')
          .pop()
          ?.toLowerCase();

        const isImage =
          file.type.startsWith('image/') ||
          imageExtensions.includes(extension);

        if (type === this.FILE_TYPE.IMAGE && !isImage) {
          this.$message.error(
            `"${file.name}" không phải là file ảnh hợp lệ.`
          );
          continue;
        }

        newFiles.push({
          file,
          type,
          url: URL.createObjectURL(file),
        });
      }

      this.files = [...this.files, ...newFiles];

      event.target.value = '';
    },
    getOptionScore() {
      for (let i = 0; i <= 10; i += 0.5) {
        this.scoreOptions.push(i);
      }
    },
    onFileChangeAudio(event) {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
      this.audioFile = files[0];
      this.audioFileUrl = URL.createObjectURL(files[0]);
      console.log(this.audioFileUrl)
    },
    removeFile(index, type) {
      const targetFile = this.files.find((file, i) => i === index && file.type === type);
      if (targetFile) {
        URL.revokeObjectURL(targetFile.url);
        this.files = this.files.filter((file, i) => !(i === index && file.type === type));
      }
    },
    async onSubmit() {
      try {
        this.loadingSubmit = true;
        const formData = new FormData();
        formData.append("marking_exam_retake_id", this.student.id);
        const audioFile = this.audioFile;
        const writingFiles = this.files.filter(f => f.type === this.FILE_TYPE.IMAGE).map(f => f.file);
        if(audioFile){
          formData.append("speaking", audioFile);
        }

        if (this.listeningScore !== null && this.listeningScore !== '') {
          formData.append("listening_score", this.listeningScore);
        }

        if (this.readingScore !== null && this.readingScore !== '') {
          formData.append("reading_score", this.readingScore);
        }

        if (writingFiles.length) {
          writingFiles.forEach(file => formData.append("writings[]", file));
        } else {
          formData.append("writings[]", "");
        }

        const res = await this.$store.dispatch(IMPORT_READING_AND_WRITING_EXAM_STUDENT, formData);
        if (!res.error) {
          this.$message.success('Import bài thi thành công')
          this.$emit('reloadData')
          this.onClose()
        }
      } catch (e) {
        this.$message.error(`${e?.data?.message??"Gửi yêu cầu thất bại!"}`);
      } finally {
        this.loadingSubmit = false;
      }
    },
    onClose() {
      this.$bvModal.hide('Import-Skill-Modal')
    },
    reloadModal() {
      this.studentInfo = null
      this.loading = false
      this.skill = []
      this.files = []
      this.loadingSubmit = false
      this.audioFile = null
      this.audioFileUrl = ''
    },
  },
  computed: {
    imageList() {
      return this.files.filter(f => f.type === this.FILE_TYPE.IMAGE);
    },
  },
}
</script>

<template>

  <b-modal hide-footer id="Import-Skill-Modal"
           :title="'XỬ LÝ LỖI BÀI LÀM CHO HỌC VIÊN: ' + (student && student.name ? student.name.toLocaleUpperCase('vi-VN') : '')"
           centered size="lg" @hide="reloadModal" no-close-on-backdrop hide-header-close>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 40px">
      <div style="display: flex; flex-direction: column">
        <span style="font-weight: 600; margin-bottom: 4px; margin-top: 20px">Nhập điểm kỹ năng nghe</span>
        <el-select v-model="listeningScore" clearable filterable placeholder="Nhập điểm kỹ năng nghe">
          <el-option
              v-for="item in scoreOptions"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex; flex-direction: column">
        <span style="font-weight: 600; margin-bottom: 4px; margin-top: 20px">Nhập điểm kỹ năng đọc</span>
        <el-select v-model="readingScore" clearable filterable placeholder="Nhập điểm kỹ năng đọc">
          <el-option
              v-for="item in scoreOptions"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 40px">
      <div style="display: flex; flex-direction: column">
        <span style="font-weight: 600; margin-bottom: 4px; margin-top: 20px">Import bài thi (Nói)</span>
        <div>
          <label for="upload-audio" class="custom-button">
            <i class="el-icon-upload"></i>
          </label>
          <input
              type="file"
              id="upload-audio"
              name="audio-files"
              accept="audio/*"
              hidden
              @change="onFileChangeAudio($event)"
          >
        </div>
        <div v-if="audioFileUrl">
          <audio controls :key="audioFileUrl">
            <source :src="audioFileUrl" type="audio/ogg">
            <source :src="audioFileUrl" type="audio/mpeg">
            Your browser does not support the audio element.
          </audio>
        </div>

      </div>
      <div style="display: flex; flex-direction: column">
          <span style="font-weight: 600; margin-bottom: 4px; margin-top: 20px">
            Import bài thi (Viết)
          </span>
        <div>
          <label for="upload-image" class="custom-button">
            <i class="el-icon-upload"></i>
          </label>
          <input
              type="file"
              id="upload-image"
              name="image-files"
              accept="image/*"
              hidden multiple
              @change="onFileChange($event, FILE_TYPE.IMAGE)"
          >
        </div>
        <div v-if="imageList.length > 0" style="display: flex; flex-direction: column; gap: 10px">
          <span style="font-weight: 600">Image</span>
          <div class="container-img">
            <div v-for="(item, index) in imageList" class="image-import" :key="index + 1 + 'image'">
              <img :src="item.url" alt="image-import"/>
              <el-button class="delete-img" @click="removeFile(index, FILE_TYPE.IMAGE)" type="text">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-secondary mr-4" :disabled="loadingSubmit" @click="onClose">Hủy bỏ</button>
      <button type="button" class="btn btn-info" :disabled="loadingSubmit"  @click="onSubmit"> <i v-if="loadingSubmit" class="el-icon-loading"></i>
        Xác nhận
      </button>
    </div>
  </b-modal>
</template>

<style scoped>
.bg-gradient__success {
  border-radius: 6px;
  color: white;
  background: linear-gradient(to right, #61A900, #89C23B);
}

.bg-gradient__warning {
  border-radius: 6px;
  background: linear-gradient(to right, #CD9401, #FFC329, #CD9401);
}

.bg-gradient__info {
  border-radius: 6px;
  background: linear-gradient(to right, #b0b0b0, #e5e4e3);
}

.container-content {
  position: relative;
  border-radius: 8px;
  border: 1px solid gray;
  width: 100%;
  overflow: hidden;
}

.container-info {
  padding: 15px 30px;
}

.container-point {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 30px;
}

.custom-button {
  width: 80px;
  border-radius: 8px;
  border: 1px dashed lightskyblue;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.image-import {
  overflow: hidden;
  position: relative;
  border: 1px solid gray;
  height: 100px;
  width: 100px;
  object-fit: contain;
  border-radius: 4px;
}

.image-import:hover i {
  color: red;
}

.container-audio {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.container-img {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
}

.delete-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.writing-entrance {
  display: block;
  color: #87CEFA;
  margin-bottom: 5px;
  margin-left: 8px;
}
</style>
